
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("42H7Z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $jEeDd = parcelRequire("jEeDd");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $jmjWc = parcelRequire("jmjWc");


const $e37c0eec4a1e0e89$export$96792f325e10e1b9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ptJjK",
    name: "BaseHeartbeatLoadable",
    loader: async ()=>await (parcelRequire("bAtQq"))
});


const $506e10f6c3cddd11$export$38f39b921d5551c1 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const onAuthenticationFailed = (0, $42omo.useCallback)(()=>push((0, $jEeDd.getLoginLink)()), [
        push
    ]);
    // Return null when stable UI is enabled for tests
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e37c0eec4a1e0e89$export$96792f325e10e1b9), {
        onAuthenticationFailed: onAuthenticationFailed
    }) : null;
};
module.exports["Heartbeat"] = $506e10f6c3cddd11$export$38f39b921d5551c1;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("bAtQq", function(module, exports) {

let $86fa3501f2372ac3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86fa3501f2372ac3$var$load("8eYa0"),
    $86fa3501f2372ac3$var$load("gQ7R7")
]).then(()=>parcelRequire('2bdAH'));

});


//# sourceMappingURL=Heartbeat.32493322.js.map
